<template>
  <div aria-live="assertive"
    class="pointer-events-none fixed bottom-0 right-0 z-[100] flex flex-col items-end gap-3 p-6 sm:p-6 max-w-sm w-full">
    <TransitionGroup tag="div" enter-active-class="transition ease-out duration-300"
      enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-200"
      leave-from-class="opacity-100" leave-to-class="opacity-0 scale-95"
      move-class="transition-all duration-300 ease-in-out" class="flex w-full flex-col gap-3">
      <BaseNotification v-for="notification in notifications" :key="notification.id" :notification="notification"
        :duration="notification.duration || 5000" @close="removeNotification" />
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import BaseNotification from "./BaseNotification.vue";
import { useNotifications } from "../useNotifications";

const { notifications, removeNotification } = useNotifications();
</script>

<style scoped>
/* Ensures the leave animation doesn't jump when items are removed from the flow */
.v-leave-active {
  position: absolute;
}
</style>
